import { makeAutoObservable } from "mobx";

export default class ArrayAttributeShelf<AttributeType> {
	public value: AttributeType[];

	constructor(initialValue: AttributeType[] = []) {
		this.value = initialValue;

		makeAutoObservable(this);
	}

	public get getFirstOne() {
		return this.value[0];
	}

	public get getLastOne() {
		return this.value[this.value.length - 1];
	}

	public addOnEnd = (...items: AttributeType[]) => {
		this.value.push(...items);
	};

	public removeLastOne = () => {
		this.value.pop();
	};

	public removeFirstOne = () => {
		this.value.shift();
	};

	public addOnStart = (...items: AttributeType[]) => {
		this.value.unshift(...items);
	};

	public setValue = (newValue: AttributeType[]) => {
		this.value = newValue;
	};
}
